import React from 'react'
import styled from 'styled-components'
import Link from 'gatsby-link'

import Location from '../components/location'

const LocationPage = () => <Location />

export default LocationPage



// WEBPACK FOOTER //
// ./src/pages/location.js